// extracted by mini-css-extract-plugin
export var completionBody = "_en-2";
export var completionCard = "_en-0";
export var completionFooter = "_en-3";
export var completionTitle = "_en-1";